import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

type PendingPaymentFinishedStatus = 'failed' | 'paid';

export const trackPendingPaymentModalShown = () => {
  MixpanelEvents.paymentPendingModalShown();
};

export const trackPendingPaymentPollingFinished = (payload: {
  durationMs: number;
  status: PendingPaymentFinishedStatus;
}) => {
  MixpanelEvents.paymentPendingPollingFinished(payload);
};
